import React, {useState, useMemo, ChangeEvent, useEffect} from 'react'
import {deleteLead, updateAddOnEnquiry} from '../../../api/index'
import {fetchEnquiryData} from '../Tables/helper'
import Swal from 'sweetalert2'

type SortConfig = {key: string; direction: 'asc' | 'desc' | null}

interface GenericTableProps {
  columns: string[]
  data: Record<string, any>[]
  searchTerm: string
  handleSort: (key: string) => void
  sortConfig: SortConfig
  handleNextClick?: (page: number) => void
  handlePriviousClick?: (page: number) => void
  //resetHandler:()=>void;
  onSearch: (term: string) => void
  pageSize?: number
  buttonConfig?: {
    label: string
    onClick: () => void
  }
  updatebutton?: boolean
  renderCell?: (column: string, row: Record<string, any>, rowIndex: number) => React.ReactNode
  conditionalClass?: string
  showCheckbox?: boolean
  RightSideElement?: JSX.Element
  LeftSideElement?: JSX.Element
}

const GenericTable: React.FC<GenericTableProps> = ({
  columns,
  data,
  searchTerm,
  onSearch,
  pageSize = 10,
  buttonConfig,
  renderCell,
  conditionalClass,
  // updatebutton,
  showCheckbox = false,
  RightSideElement,
  LeftSideElement,
  handleSort,
  sortConfig,
}) => {
  const [currentPage, setCurrentPage] = useState<number>(1)

  const [selectedRows, setSelectedRows] = useState<number[]>([])
  const [paginatedData, setPaginatedData] = useState<any[]>([])

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    onSearch(event.target.value)
  }

  const filteredData = useMemo(() => {
    return data.filter((row) =>
      Object.values(row).join(' ').toLowerCase().includes(searchTerm.toLowerCase())
    )
  }, [data, searchTerm])

  const handleCheckboxChange = (index: number) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(index)
        ? prevSelected.filter((row) => row !== index)
        : [...prevSelected, index]
    )
  }

  const handleSelectAll = () => {
    if (selectedRows.length === data.length) {
      setSelectedRows([])
    } else {
      setSelectedRows(data.map((_, index) => index))
    }
  }

  const handleDelete = async () => {
    try {
        console.log("Selected rows:", selectedRows);
        console.log("Data before deletion:", data);

        await Promise.all(selectedRows.map((rowIndex) => {
            const leadId = data[rowIndex]?.id; // Ensure ID exists
            if (!leadId) {
                console.error("Invalid lead ID:", data[rowIndex]);
                return Promise.resolve(); // Avoid breaking Promise.all
            }
            return deleteLead(leadId);
        }));

        const updatedData = data.filter((_, index) => !selectedRows.includes(index));
        setPaginatedData(updatedData);
        setSelectedRows([]);
    } catch (error) {
        console.error("Error deleting selected leads:", error);
    }
};

  useEffect(() => {
    const startIndex = (currentPage - 1) * pageSize
    const endIndex = startIndex + pageSize
    setPaginatedData(filteredData.slice(startIndex, endIndex))
  }, [filteredData, currentPage, pageSize])

  

  return (
    <>
      <div className='flex-lg-row-fluid'>
        <div className={conditionalClass}>
          <div className='card-header pt-3'>
            <div
              className='card-title'
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              {/* Left-aligned search input */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  position: 'relative',
                }}
              >
                {/* Search Bar & Left Element */}
                <div style={{display: 'flex', alignItems: 'center', width: '100%'}}>
                  <div style={{position: 'relative', display: 'flex', alignItems: 'center'}}>
                    <i
                      className='ki-duotone ki-magnifier fs-1'
                      style={{
                        position: 'absolute',
                        left: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                      }}
                    >
                      <span className='path1'></span>
                      <span className='path2'></span>
                    </i>
                    <input
                      type='text'
                      value={searchTerm}
                      onChange={handleSearchChange}
                      data-kt-roles-table-filter='search'
                      className='form-control form-control-solid w-250px ps-15'
                      placeholder='Search Users'
                      style={{paddingLeft: '35px'}} // Adjust padding to accommodate icon
                    />
                  </div>

                  {/* Left Side Element */}
                  {LeftSideElement && (
                    <div style={{marginLeft: '10px', display: 'flex', alignItems: 'center'}}>
                      {LeftSideElement}
                    </div>
                  )}
                </div>

                {/* Delete Button Below Input */}
                {selectedRows.length > 0 && (
                  <div style={{marginTop: '10px'}}>
                    <button
                      className='btn btn-outline btn-outline-dashed btn-outline-danger btn-active-light-danger'
                      onClick={handleDelete}
                      style={{
                        padding: '4px',
                      }}
                    >
                      Delete {selectedRows.length} {selectedRows.length === 1 ? 'User' : 'Users'}
                    </button>
                  </div>
                )}
              </div>

              {/* Right-aligned "Hello" */}
              <div style={{width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
                {/* {updatebutton &&
                  <button
                    type="button"
                    className="btn"
                    // disabled={selectedRows.length === 0}
                    onClick={handleUpdateClick}
                    style={{
                      backgroundColor: "#6D9300",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      padding: "10px 20px",
                      color: "#fff",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                      
                    }}
                  >Update Enquires</button>
                } */}
                {/* <DaysDropdown /> */}
                <div>
                  {buttonConfig?.label && (
                    <button
                      type='button'
                      className='btn'
                      onClick={buttonConfig.onClick}
                      style={{
                        backgroundColor: '#6D9300',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        padding: '10px 20px',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        marginLeft: '2vw',
                      }}
                    >
                      <i className='ki-solid ki-abstract-10' style={{color: '#fff'}}></i>
                      {buttonConfig.label}
                    </button>
                  )}
                </div>

                {RightSideElement && <div>{RightSideElement}</div>}
              </div>
              {/* 
              <div style={{ marginLeft: "auto", ...(buttonConfig?.label && { width: "19vw" }) }}>

              </div> */}

              <div>{/* <RecentOrders onTabClick={handleTabClick} /> */}</div>
            </div>
          </div>
          <div className='card-body pt-0' style={{overflowX: 'auto'}}>
            <div style={{overflowX: 'auto'}}>
              <table className='table table-striped align-middle fs-6 gy-5 mb-0'>
                <thead>
                  <tr className='text-start fw-bold fs-7 gs-0'>
                    {showCheckbox && (
                      <th className='w-30px pe-2'>
                        <div className='form-check form-check-sm form-check-custom form-check-solid me-3'>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            onChange={() => handleSelectAll()}
                            checked={selectedRows.length === data.length}
                          />
                        </div>
                      </th>
                    )}

                    {columns.map((column, index) => (
                      <th
                        key={index}
                        onClick={() => handleSort(column)}
                        style={{
                          width: `${100 / columns.length}%`, // Distribute width equally
                          minWidth: '120px', // Prevent columns from becoming too narrow
                          textAlign: 'left',
                          whiteSpace: 'nowrap',
                          position: 'relative',
                        }}
                      >
                        {column}
                        <span style={{marginLeft: '8px', display: 'inline-block'}}>
                          {sortConfig.key === column ? (
                            sortConfig.direction === 'desc' ? (
                              <span
                                style={{
                                  marginLeft: '4px',
                                  color: 'blue',
                                }}
                              >
                                ↓
                              </span>
                            ) : (
                              <span
                                style={{
                                  marginLeft: '4px',
                                  color: 'blue',
                                }}
                              >
                                ↑
                              </span>
                            )
                          ) : (
                            // Show both arrows for unsorted
                            <>
                              <i className='ki-solid ki-arrow-up-down'></i>
                            </>
                          )}
                        </span>
                      </th>
                    ))}
                  </tr>
                </thead>
                {filteredData.length === 0 ? (
                  <tbody>
                    <tr>
                      <td colSpan={columns.length} style={{textAlign: 'center', padding: '20px'}}>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            color: '#555',
                          }}
                        >
                          <i
                            className='fas fa-search'
                            style={{fontSize: '36px', color: '#ccc'}}
                          ></i>
                          <span style={{marginTop: '10px', fontSize: '16px', fontWeight: '500'}}>
                            No data found
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody className='fw-semibold text-gray-600'>
                    {paginatedData.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {showCheckbox && (
                          <td className='w-30px pe-2'>
                            <div className='form-check form-check-sm form-check-custom form-check-solid me-3'>
                              <input
                                className='form-check-input'
                                type='checkbox'
                                checked={selectedRows.includes(rowIndex)}
                                onChange={() => handleCheckboxChange(rowIndex)}
                              />
                            </div>
                          </td>
                        )}
                        {columns.map((column, colIndex) => (
                          <td key={colIndex}>
                            {renderCell ? renderCell(column, row, rowIndex) : row[column]}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default GenericTable
